import { useLayoutEffect, useRef, type FC } from 'react'

import { List } from '@dhl-ui/components'

import { type Servicepoint } from './model.js'
import { ServicepointListItem } from './ServicepointListItem.js'

type Props = {
  'data-testid'?: string
  expandedServicepointKey?: string
  servicepoints: Servicepoint[]
  onClick?: (servicepoint: Servicepoint) => void
  onSelect?: (servicepoint: Servicepoint) => void
  showOpeningTimes?: boolean
  isDesktop?: boolean
  useDialogSelect?: boolean
}

export const ServicepointList: FC<Props> = ({
  'data-testid': dataTestId,
  isDesktop = false,
  servicepoints,
  showOpeningTimes = true,
  useDialogSelect = false,
  onClick,
  onSelect,
  expandedServicepointKey,
}) => {
  const listItemRefs = useRef({} as Record<string, HTMLDivElement | null>)

  useLayoutEffect(() => {
    if (expandedServicepointKey) {
      const element = listItemRefs.current[expandedServicepointKey]
      element?.scrollIntoView({ behavior: 'instant', block: 'center' })
    }
  }, [expandedServicepointKey])

  return (
    <List data-testid={dataTestId}>
      {servicepoints.map((servicepoint, index) => (
        <ServicepointListItem
          defaultExpanded={
            servicepoint.servicepointKey === expandedServicepointKey ||
            (!expandedServicepointKey && isDesktop && index === 0)
          }
          key={servicepoint.servicepointKey}
          servicepoint={servicepoint}
          divider={servicepoints.length > index + 1}
          ref={(el) => {
            listItemRefs.current[servicepoint.servicepointKey] = el
          }}
          showOpeningTimes={showOpeningTimes}
          isDesktop={isDesktop}
          useDialogSelect={useDialogSelect}
          onClick={onClick}
          onSelect={onSelect}
        />
      ))}
    </List>
  )
}
